import { produccionConcesionariaSections } from './produccionConcesionariaSections';

export const produccionConcesionariaManual = {
  id: 'mod-produccion-concesionaria',
  title: 'Producción concesionaria',
  isVisible: (ctx) => ctx.canSeeProduccionConcesionaria,
  intro:
    'Operación de comedores y concesiones: área de despacho, plantillas del cuadro venta-producción, cuadro del día, dashboard, planeamiento cíclico y operaciones de almacén (salidas y despacho). Las secciones visibles dependen de los flags de módulo, igual que el menú lateral.',
  sections: produccionConcesionariaSections,
};
